<template>
  <router-view />
</template>
<script>
export default {
  name: 'LanguageRoot',
};
</script>
